import { Component } from '@angular/core';
import { ApiServiceListService } from 'src/app/_services/api/api-service-list.service';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import {  ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/_services/common/common.service';
import { LocalizedString } from 'src/app/model/localized-string.model';
import { categoryModelOptions, categoryTypeOptions } from 'src/assets/config/constants';

@Component({
    selector: 'app-add-category',
    templateUrl: './add-category.component.html',
    styleUrl: './add-category.component.css',
    standalone: false
})
export class AddCategoryComponent {
  showLoader: boolean = false;
  showMainCategory: boolean = false;
  showCategory: boolean = false;
  isCategoryTypeLocked: boolean = false;
  isMainCategoryLocked: boolean = false;
  model: any = {
    name: { en: '', te: '' },
    description: '',
    status: true,
    type: 'category',
    model: 'product',
    rank: 0
  };
  public breadcrumb: any;
  options = {
    close: false,
    expand: false,
    minimize: false,
    reload: false
  };
  mainCategoryList: any = [];
  categoryList: any = [];
  categoryTypeOptions = categoryTypeOptions;
  availableCategoryTypeOptions = categoryTypeOptions;
  categoryModelOptions = categoryModelOptions;
  dropdownSettings: any = {};
  private routeSub: Subscription;
  isEditPage: boolean = false;
  
  constructor(private route: ActivatedRoute, private apiService: ApiServiceListService, private http: HttpClient, private toastr: ToastrService, private router: Router, private cmnService: CommonService) { }

  ngOnInit() {

    this.routeSub = this.route.params.subscribe(params => {
      if (params != undefined && params['id'] != undefined) {
        this.isEditPage = true
        this.getCategoryById(params['id']);
      } else {
        this.isEditPage = false;
        this.onCategoryModelChange();
      }
    });
    
    this.breadcrumb = {
      'mainlabel': 'Category Management',
      'links': [
        {
          'name': this.isEditPage ? 'Edit Category ' : 'Add Category ',
          'isLink': false,
          'link': '#'
        },
      ]
    };
    this.dropdownSettings = {
      singleSelection: true,
      idField: '_id',
      textField: 'displayName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      closeDropDownOnSelection: true
    };

  }

  private toLocalizedString(value: any): LocalizedString {
    return this.toLocalizedStringWithFallback(value);
  }

  private getFirstNonEmptyString(values: any[] = []): string {
    const validValue = values.find(item => typeof item === 'string' && item.trim() !== '');
    return typeof validValue === 'string' ? validValue : '';
  }

  private toLocalizedStringWithFallback(value: any, teFallbacks: any[] = [], enFallbacks: any[] = []): LocalizedString {
    let en = '';
    let te = '';

    if (value && typeof value === 'object' && !Array.isArray(value)) {
      en = this.getFirstNonEmptyString([
        value.en,
        value.english,
        value.enUS,
        value.en_us,
        value['en-US'],
        value['en-IN'],
      ]);

      te = this.getFirstNonEmptyString([
        value.te,
        value.telugu,
        value.teIN,
        value.te_in,
        value['te-IN'],
      ]);
    } else if (typeof value === 'string') {
      en = value;
    }

    if (!en) {
      en = this.getFirstNonEmptyString(enFallbacks);
    }
    if (!te) {
      te = this.getFirstNonEmptyString(teFallbacks);
    }

    return { en, te };
  }

  getLocalizedText(value: any): string {
    const localized = this.toLocalizedString(value);
    return localized.en || localized.te || '';
  }

  private withDisplayName(item: any): any {
    if (!item || typeof item !== 'object') {
      return item;
    }
    return {
      ...item,
      displayName: this.getLocalizedText(item.name),
    };
  }

  private mapCategoryList(list: any[] = []): any[] {
    return list.map(item => this.withDisplayName(item));
  }

  private getSelectedId(selection: any): any {
    const selectedItem = Array.isArray(selection) ? selection[0] : selection;
    return selectedItem?._id ?? selectedItem;
  }

  private getAllowedCategoryTypeOptions(categoryModel: string): any[] {
    if (categoryModel === 'kitchen' || categoryModel === 'product') {
      return this.categoryTypeOptions.filter((option) => option.id !== 'main');
    }

    if (categoryModel === 'service') {
      return this.categoryTypeOptions.filter((option) => option.id === 'main' || option.id === 'category');
    }

    if (categoryModel === 'package') {
      return this.categoryTypeOptions.filter((option) => option.id === 'main');
    }

    return this.categoryTypeOptions;
  }

  private updateCategoryVisibility(): void {
    this.showMainCategory = this.model.type === 'category' || this.model.type === 'sub';
    this.showCategory = this.model.type === 'sub';
  }

  isCategoryTypeDisabled(): boolean {
    return this.isCategoryTypeLocked || (this.isEditPage && this.model.model !== 'service');
  }

  getCategoryById(id: string) {
    let parameter: any = {
      methodType: "GET",
    }

    this.apiService.getCategoryById(parameter, id)
      .subscribe({
        next: (response: any) => {
          if(response.success){
            const category = response.data;
            category.name = this.toLocalizedStringWithFallback(category.name, [
              category.nameTe,
              category.name_te,
              category.teName,
              category.teluguName,
            ]);
            category.description = category.description;
            category.mainCategory = this.withDisplayName(category.mainCategory);
            category.category = this.withDisplayName(category.category);
            category.model = category.model || 'product';
            if (category.model === 'service' && category.mainCategory) {
              category.mainCategory = [category.mainCategory];
            }
            this.model = { ...category };
            this.model.status = this.cmnService.getStatusRetrunValue(this.model.status);
            this.availableCategoryTypeOptions = this.getAllowedCategoryTypeOptions(this.model.model);
            this.isCategoryTypeLocked = this.model.model === 'package';
            this.isMainCategoryLocked = this.model.model === 'kitchen';
            this.updateCategoryVisibility();
            if (this.model.model === 'service' && this.showMainCategory) {
              this.getMainCategory('service');
            }
          }
        },
        error: (err) => {
          console.log(err);
        },
        complete: () => {
        }
      });

  }

  // selection of category type
  cateTypeSelect() {
    this.updateCategoryVisibility();

    if (this.isEditPage) {
      if (this.model.model !== 'service') {
        return;
      }

      this.model.category = undefined;
      this.categoryList = [];

      if (this.showMainCategory) {
        if (!Array.isArray(this.model.mainCategory)) {
          this.model.mainCategory = this.model.mainCategory ? [this.model.mainCategory] : [];
        }
        this.getMainCategory('service');
      } else {
        this.model.mainCategory = undefined;
        this.mainCategoryList = [];
      }
      return;
    }

    this.model.mainCategory = undefined;
    this.model.category = undefined;
    this.mainCategoryList = [];
    this.categoryList = [];
    this.isMainCategoryLocked = this.model.model === 'kitchen' && this.showMainCategory;

    if (!this.showMainCategory) {
      return;
    }

    if (this.model.model === 'kitchen') {
      this.loadKitchenMainCategory();
      return;
    }

    if (this.model.model === 'product' || this.model.model === 'service') {
      this.getMainCategory(this.model.model);
    }
  }

  onCategoryModelChange() {
    if (this.isEditPage) {
      return;
    }

    this.availableCategoryTypeOptions = this.getAllowedCategoryTypeOptions(this.model.model);
    this.isCategoryTypeLocked = this.model.model === 'package';

    if ((this.model.model === 'kitchen' || this.model.model === 'product') && this.model.type === 'main') {
      this.model.type = 'category';
    }

    if (this.model.model === 'package' && this.model.type !== 'main') {
      this.model.type = 'main';
    }

    if (this.model.model === 'service' && this.model.type === 'sub') {
      this.model.type = 'category';
    }

    this.cateTypeSelect();
  }

  getMainCategory(categoryModel: string = this.model.model) {
    console.log('MAin');

    let parameter: any = {
      methodType: "GET",
    }
    this.apiService.getMainCategoryList(parameter, categoryModel).subscribe({
      next: (response: any) => {
        this.mainCategoryList = this.mapCategoryList(response.data);
      },
      error: (err) => {
        console.log(err);
      },
      complete: () => {
        console.log("Comple");

      }
    });
  }

  private loadKitchenMainCategory() {
    let parameter: any = {
      methodType: "GET",
    };

    this.apiService.getKitchenMainCategory(parameter).subscribe({
      next: (response: any) => {
        const kitchenMainCategory = response?.data ? this.withDisplayName(response.data) : null;
        if (!kitchenMainCategory) {
          this.model.mainCategory = undefined;
          this.mainCategoryList = [];
          this.categoryList = [];
          return;
        }

        this.mainCategoryList = [kitchenMainCategory];
        this.model.mainCategory = [kitchenMainCategory];

        if (this.model.type === 'sub') {
          this.getCategory();
        }
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

  getCategory() {
    if (!this.model.mainCategory?.[0]) return;

    let parameter: any = {
      methodType: "POST",
    }
    let body: any = {};
    body.mainCategory = this.model.mainCategory[0]?._id ?? this.model.mainCategory[0];
    this.apiService.getCategoryList(parameter, body).subscribe({
      next: (response: any) => {
        this.categoryList = this.mapCategoryList(response.data);
      },
      error: (err) => {
        console.log(err);
      },
      complete: () => {

      }
    });
  }

  onMainCateChange() {
    this.model.category = undefined;
    this.categoryList = [];

    if (this.model.type == 'sub') {
      this.getCategory();
    }
  }


  addCategory(valid) {

    this.showLoader = true;

    if (valid) {
      let body: any = {};
      body = { ...this.model };
      body.name = this.toLocalizedString(this.model.name);

      if (!this.isEditPage) {
        if (body.model === 'package') {
          body.type = 'main';
          delete body.category;
          delete body.mainCategory;
        } else if (body.model === 'kitchen') {
          body.mainCategory = this.getSelectedId(this.model.mainCategory);
          if (this.showCategory) {
            body.category = this.getSelectedId(this.model.category);
          } else {
            delete body.category;
          }
        } else if (this.showCategory) {
          body.category = this.getSelectedId(this.model.category);
          body.mainCategory = this.getSelectedId(this.model.mainCategory);
        } else if (this.showMainCategory) {
          body.mainCategory = this.getSelectedId(this.model.mainCategory);
        } else {
          delete body.category;
          delete body.mainCategory;
        }
      } else if (body.model === 'service') {
        if (body.type === 'category') {
          body.mainCategory = this.getSelectedId(this.model.mainCategory);
          delete body.category;
        } else {
          body.type = 'main';
          delete body.category;
          delete body.mainCategory;
        }
      }

      body.mainCategory = this.getSelectedId(body.mainCategory);
      body.category = this.getSelectedId(body.category);

      if (typeof this.model.status === 'boolean') {
        body.status = this.cmnService.getStatusValue(this.model.status);
      } else {
        body.status = this.model.status;
      }
      // if (this.model.status) {
      //   body.status = 'Active'
      // } else {
      //   body.status = 'InActive'
      // }
      // console.log(this.model);
      console.log(body);
      this.showLoader = true;
      // return;
      if (this.isEditPage) {
        let parameter: any = {
          methodType: "PUT",
        }
        this.apiService.updateCategory(parameter, body).subscribe({
          next: (response: any) => {

            if (response.status === 'Success') {
              this.toastr.success(response.message, '', {
                timeOut: 3000,
              });
              this.router.navigateByUrl('/category/all');
            } else {
              this.toastr.error(response.message, '', {
                timeOut: 3000,
              });
            }
            this.showLoader = false;
          },
          error: (err) => {
            console.log(err);
            this.showLoader = false;
          }

        });
      } else {
        let parameter: any = {
          methodType: "POST",
        }
        this.apiService.addCategoryAPI(parameter, body).subscribe({
          next: (response: any) => {
            if (response.success) {
              this.toastr.success(response.message, '', {
                timeOut: 3000,
              });
              this.router.navigateByUrl('/category/all');

            } else {
              this.toastr.error(response.message, '', {
                timeOut: 3000,
              });
            }
            this.showLoader = false;
          },
          error: (err) => {
            console.log(err);
            this.showLoader = false;
          }
        });
      }

    } else {
      this.showLoader = false;
    }

  }

  navigateTOList() {
    this.router.navigateByUrl('/category/all');
  }

}
